export default {
    tower: {
        activeCommands: "Active Commands",
        altCertUrl: "Alternative Certificate URL",
        metricsNav: "Metrics",
        metricsList: "Base Stations List",
        metricsDashboard: "Base Stations Dashboard",
        netConfig: "Network Configuration",
        id: "ID",
        bank:"Bank Name",
        baseStations: "Base Stations",
        selectedBaseStations: "Selected Base Stations",
        baseStation: "Base Station",
        baseStationDetails: 'Base Station Details',
        baseStationId: 'Base Station ID',
        baseStationIdString: 'ID',
        uplinkMessageAverage: "Uplink Messages",
        baselineUplinkMessageAverage: "Baseline Uplink Message Average",
        baselineUplinkMessageStdDev:"Baseline Uplink Messages Standard Deviation",
        baselineUplinkMessageStartTime: "Baseline Average Start Time",
        baselineUplinkAverageReset: "Reset Uplink Baseline Average Start Time",
        lastHourUplinkMessageAverage:"Last Hour Uplink Message Average",
        lastHourUplinkAverageHasZeros:"At least one 15 minute interval in the last hour had zero uplink messages",
        disconnectTxt: "Unknown Reason",
        cmdDisabled: "Command processing for Base Stations is disabled",
        cmdEnabled: "Command processing for Base Stations is enabled",
        seriesFrequency: 'Freq',
        general: 'General',
        timestamps: 'Timestamps',
        commsSection: 'Communication Options',
        onBattery: "On Battery",
        gpsOk: 'GPS OK',
        gpsFix: 'GPS Fix',
        confirm:"Confirm",
        satelliteCount: 'Satellite Count',
        timeZone: 'Time Zone',
        location: 'Location',
        latitude: 'Latitude',
        longitude: 'Longitude',
        altitude: 'Altitude (meters)',
        region: 'Region',
        address: 'Address',
        name: 'Name',
        enableRouting: 'Enable RNI Routing',
        disableRouting: 'Disable RNI Routing',
        changeRoutingError: 'Error enabling/disabling RNI routing',
        routingEnabled: "Routing enabled command sent to base stations",
        routingDisabled: "Routing disabled command sent to base stations",
        rniStatus: 'RNI Status',
        rniStatusValues: {ONLINE: 'Online', null: 'Unknown', OFFLINE: 'Offline'},
        rniRoutingEnabled: 'RNI Routing Enabled',
        description: 'Description',
        andorianVersion: 'Andorian Version',
        enclosureType: 'Enclosure Type',
        transceiverType: 'Transceiver Type',
        softwareVersion: 'Software Version',
        softwareVersionHeader: 'Software Version',
        softwareType: 'Software Vintage',
        powerMonitorType: 'Power Monitor Type',
        powerMonitorVersion: 'Power Monitor Version',
        transmitMode: 'Transmit Mode',
        kFactor: 'K-Factor',
        transmitSlot: 'Transmit Slot',
        ifNotRandom: '(if not random)',
        momCommEnabled: 'MOM Comm Enabled',
        momCommSent: 'MOM Comm Sent',
        commandRatio: 'Command Ratio',
        radioSingleRoutesCount: 'Daily Single Uplink Routes (Yesterday)',
        radioSingleRoutesCountSPR: 'Daily Single Uplink Routes',
        radioAllRoutesCount: 'Daily All Uplink Routes (Yesterday)',
        radioAllRoutesCountSPR: 'Daily All Uplink Routes',
        latlong: 'Lat/Long',
        alarmCount: 'Alarm Cnt',
        alarms: 'Active Alarms',
        alarmsActiveTotal: 'Total Active Alarms',
        alarmsActiveSuppressed: 'Active Alarms Suppressed',
        alarmsActiveUnsuppressed: 'Active Alarms Unsuppressed',
        city: 'City',
        state: 'State',
        zipCode: 'Zip Code',
        postalCode: 'Postal Code',
        defaultPowerAttenuation: "Planned Power Attenuation dB",
        configuredPowerAttenuation: "Configured Power Attenuation dB",
        zip: 'Zip',
        createTower: 'Create Base Station',
        lastHeard: 'Last Heard',
        lastHeardMOA: 'Last Heard (On Air)',
        lastHeardMOATitle: 'Last message received from any endpoint associated with this customer',
        lastHeardMOAMinutes: 'Last Heard Minutes (On Air)',
        lastHeardMOAHours: 'Last Heard Hours (On Air)',
        lastHeardNonMOA: 'Last Heard (Non On Air)',
        lastUplinkMessageReceived: 'Last Uplink Message Received',
        lastUplinkMessageReceivedTitle: 'Last non-zero uplink message count reported by this base station across all associated customers',
        firstHeard: 'First Heard',
        firstHeardRni: 'First Heard by RNI',
        discovered: "Discovered",
        lastConfigChange: 'Last Config Change',
        lastTgbProgsRestart: 'Last Application Restart',
        lastMetadataUpdate:"Last Metadata Update Date",
        ntpMaximumError: 'NTP Maximum Error',
        bitrate:"Time Broadcast Bitrate",
        bitrates:{
            0 : "5 kbps mPass",
            1 : "10 kbps mPass2",
            2 : "Both 5 kbps and 10 kbps mPass in two broadcasts",
            3 : "10 kbps 4GFSK m4Pass",
            4 : "20 kbps 4GFSK m4Pass2",
        },
        broadcastType: "Time Broadcast Type",
        broadcastTypes:{
            1 : "FNV1 Time Broadcast",
            2 : "FNV2 FlexType 4 Poll Response Time Broadcast",
            3 : "FNV2 FlexType 1 Time Broadcast",
            4 : "FNV1 MoMComm Variable Interval",
        },
        broadcastInterval:"Time Sync Interval",
        lastTransmit: 'Last Transmit Report',
        lastEnqueueReport: "Last Enqueue Report",
        lastEnqueueReportDuration: "Last Enqueue Report Age",
        lastQueueReport: "Last Queue Report",
        lastQueueReportDuration: "Last Queue Report Age",
        lastConfigRetrieval: "Last Config Retrieval",
        lastRead: 'Last Read Msg',
        updateTower: 'Update Base Station',
        deleteTower: 'Delete Base Station',
        deleteTowerPrompt: 'Are you sure you want to delete base station {baseStationId}?',
        deleteTowerError: 'Error deleting base station {baseStationId}',
        getManifestError: "Error in fetch manifest{baseStationId}",
        disconnected: 'Disconnected',
        cancelRebootAlert:"Cancel Reboot",
        reload: "Reconnect",
        close: "Close",
        towerDeleted: 'Base Station {baseStationId} was successfully deleted',
        transmitChannels: 'Transmit Channels',
        receiveChannels: 'Receive Channels',
        slotInformation: 'Slot Information',
        unified: 'Unified',
        frequencyNumber: 'Frequency #',
        frequency: 'Frequency (MHz)',
        width: 'Width (kHz)',
        lastUsed: 'Last Used',
        averageNoise: 'Average Noise',
        averageSignal: 'Average Signal',
        nmsAverageNoise: 'NMS Average Noise',
        nmsAverageSignal: 'NMS Average Signal',
        hardwareId: 'Hardware ID',
        hardwareChainNumber: 'Hardware Chain #',
        receiverNumber: 'Receiver #',
        channelAttributes: {
            title: 'Attributes',
            tooltips: {
                primary: 'Primary',
                secondary: 'Secondary',
                admin: 'Admin',
                buddy: 'buddy',
                fwdl: 'Firmware Download',
                install: 'Install'
            }
        },
        modulation: 'Modulation',
        modulationsPlanned: 'Planned Modulations',
        slot: 'Slot',
        centerFrequency: 'Center Frequency (MHz)',
        channelWidth: 'Channel Width (kHz)',
        demodulatorType: 'Demodulator Type',
        createDate: 'Created',
        bestTuningUplinkCount: 'Best Tuning Uplink Count',
        clickToDisplayDetails: 'Click to display base station details',
        clickToDisplayRadiosSingle: 'Click to display radios that have a single uplink route to this base station',
        clickToDisplayRadiosAll: 'Click to display radios that have an uplink route to this base station',
        clickToDisplayBestTuningUplink: 'Click to display radios that have this base station as their best tuning uplink',
        sets: 'Sets',
        setCreated: 'Set \'{name}\' created successfully',
        setDeleted: 'Set \'{name}\' deleted successfully',
        setUpdated: 'Set \'{name}\' updated successfully',
        stales: "Stales",
        staleMinutes: "Threshold minutes 5 - 60",
        staleHours: "Threshold hours 1 - 999",
        towerConfig: 'Base Station Configuration',
        ipAddress: 'IP Address',
        primaryIpAddress: 'Primary IP Address',
        altIpAddress: 'Alternative IP Address',
        configuredIpAddresses: 'Configured IP Addresses',
        sshPort: "SSH Port",
        networkPlanConfigStatus: 'Network Plan Config Status',
        configCommandStatus: 'Config Command Status',
        configCommandDate: 'Last Config Change Sent',
        networkPlanConfigDate: 'Network Plan Config Date',
        deploymentStatus: 'Network Plan Deployment Status',
        deploymentDate: 'Network Plan Deployment Date',
        planned: 'Planned',
        messages: 'Messages',
        selectTowerDialog: {
            title: 'Select a Base Station',
            btn: 'Select'
        },
        networkPlan: {
            label: 'Network Plan',
            upload: {
                label: 'Upload Network Plan',
                initialMessages: 'Please select files for upload.',
            },
            deploy: {
                label: "Deploy Network Plan",
                all: "Deploy Network Plan to All",
                set: "Deploy Network Plan to Set",
                selected: "Deploy Network Plan to Selected",
                config: {
                    hint: "The configuration to be merged with the Network Plan on deployment."
                }
            },
            lastUploaded: "Network Plan Last Uploaded",
            noLastImport: "No Network Plan Available",
            channelConfig: 'Select Channel Configuration File',
            siteList: 'Select Site List File',
        },
        selectFiles: 'Please select files to upload.',
        deployConfigToSelected: 'Deploy Configuration to Selected',
        deployConfigToAll: 'Deploy Configuration to All',
        setSecurityOnSelected: 'Configure Base Station Security',
        uploadSuccess: 'Uploaded successfully.',
        uploadFailure: 'Errors found! No changes implemented.',
        uploadInProgress: 'Upload in progress.',
        lastUploaded: 'Last Uploaded',
        deployTowers: 'Deploy to Selected Base Stations',
        deployTowersAll: 'Deploy to All Base Stations',
        selectConfigToDeploy: 'Select Config to Deploy',
        selectVersion: 'Select Configuration Version',
        protocol: "Select Preferred Protocol",
        globalConfig: 'Global Config',
        lastKnownConfig: 'Last Known Config',
        userId: 'User ID',
        password: 'Password',
        deploySuccess: 'Network Plan deployment command successfully queued for the selected base station(s). You may monitor the status in Active Commands or on the individual base station(s) history.',
        deployInProgress: 'Network Plan deployment initiated...',
        deployFailure: 'Network Plan deployment command failed.',
        securityInProgress: 'Security configuration request in progress.',
        securitySuccess: 'Security configuration queued.',
        securityFailure: 'Security configuration failed!',
        secureTowers: 'Configure Base Station Security',
        securityConfigDate: 'Security Config Date',
        securityConfigStatus: 'Security Config Status',
        notPlannedWarning: 'Warning: Base stations that are "Not Planned" will be skipped.\nYou have selected the following base stations with this status: ',
        transmitter: "Transmitter",
        radioCount: "Radio Count",
        cpcCards: "CPC Cards",
        cardNumber: "Card Number",
        tipFw: "TIP Firmware Version",
        dsp1Fw: "DSP1 Firmware Version",
        dsp2Fw: "DSP2 Firmware Version",
        fpga1Fw: "FPGA1 Firmware Version",
        fpga2Fw: "FPGA2 Firmware Version",
        onBoardError: 'Base Station {id} has not been on-boarded, this action is not valid',
        noOnboardedEror: 'No onboarded base stations found.',
        csvColumnError:'CSV file should contain Base Station ID column',
        skip: "Base Stations skipped due to invalid ",
        duplicate: "Base Stations skipped due to duplicate configutation",
        defaultSshPort:"Base Stations skipped to aviod duplicate SSH Port by assigning default value",
        sshPortError:"Invalid SSH Port {port}",
        download: "Download",
        cancel: "Cancel",
        downloaded: "File downloaded",
        upload:"Upload",
        selectFile: "Select File",
        selectDestination: "Enter Destination",
        downloadFile: "Enter full path",
        errDownload : "Failed You do not have permission to download this file",
        err: "Failed ",
        errUpload : "Failed You do not have permission to upload a file to the selected directory",
        success: "Successfully Uploaded",
        csvParseIssues: "CSV Upload Parse Issues",
        csvSkippedTowers: "Base Stations skipped due to missing information",
        getFile: "Download Remote File",
        putFile: "Upload Local File",
        latest: "Latest Software Version",
        booted: "Booted",
        lastinstalled:"Last Installed",
        fixTowerTime: "Correct Base Station Time",
        retrySsh: "Retry SSH Connection",
        socketConnectionError: "Failed to establish an SSH connection to the base station.",
        socketConnectionHint: "It is recommended to use an HTTPS connection when using the terminal.",
        ncsCommandTypesNA: {
            TOWER_PROVISION_NCS: "Provision a Base Station",
            TOWER_INSTALL_SOFTWARE: "Install Release on Base Station",
            TOWER_APPLY_CONFIG: "Configure a Base Station",
            TOWER_CANCEL_REBOOT: "Cancel Base Station Reboot",
            TOWER_REBOOT: "Base Station Reboot",
            TOWER_SCHEDULE_REBOOT: "Scheduled Base Station Reboot",
            TOWER_REFRESH_CERT: "Base Station Cert Refresh",
            TOWER_ADD: "Add a Base Station",
            TOWER_EDIT: "Edit a Base Station",
            TOWER_GET_METADATA: "Getting meta data for Base Station",
            TOWER_ROTATE_PASSWORD:"Base Station Rotate Password",
            TOWER_CORRECT_TIME_DRIFT: "Correct Base Station Time",
            TOWER_DEPLOY_NETWORK_PLAN: "Deploy Network Plan",
            TOWER_REONBOARD: "Re-onboarding Base Station",
            TOWER_ONBOARD: "Onboard Base Station"
        },
        ncsCommandTypesArqiva: {
            TOWER_ROUTING_STATUS: "Ping Base Station Status",
            TOWER_PROVISION_NCS: "Provision a Base Station",
            TOWER_INSTALL_SOFTWARE: "Install Release on Base Station",
            TOWER_APPLY_CONFIG: "Configure a Base Station",
            TOWER_CANCEL_REBOOT: "Cancel Base Station Reboot",
            TOWER_REBOOT: "Base Station Reboot",
            TOWER_SCHEDULE_REBOOT: "Scheduled Base Station Reboot",
            TOWER_REFRESH_CERT: "Base Station Cert Refresh",
            TOWER_ADD: "Add a Base Station",
            TOWER_EDIT: "Edit a Base Station",
            TOWER_GET_METADATA: "Getting meta data for Base Station",
            TOWER_ROTATE_PASSWORD:"Base Station Rotate Password",
            TOWER_CORRECT_TIME_DRIFT: "Correct Base Station Time",
            TOWER_DEPLOY_NETWORK_PLAN: "Deploy Network Plan",
            TOWER_REONBOARD: "Re-onboarding Base Station",
            TOWER_ONBOARD: "Onboard Base Station"
        },
        config: {
            active: "Active",
            protocolWarn:"https connections may fall back to http if https is not feasible",
            compareModalTitle: "Compare Configuration",
            compareModalText: "Compare historical base station configurations by date.",
            restoreModalText: "Compare and restore historical base station configurations by date.",
            confirmModalTitle: "Confirm Configuration Restore",
            confirmModalText: "Please confirm your decision to restore the configuration from:",
            confirmModalUpdateText: "The active schema differs from the restored configuration. Please save and update the configuration manually. <br /><br /><strong>Warning:</strong> This will overwrite any undeployed configuration changes on the base station.",
            noData: "No data to display",
            noManifest: "No manifest available for selected bank",
            acTab: "Active Commands",
            activeConfig: "Active Configuration",
            pastConfig: "Past Configuration",
            updatedConfig: "Updated Configuration",
            configDate: "Configuration Date",
            activeConfigActions: "Active Configuration Actions",
            deployToSet: "Deploy To Set",
            networkPlan: "Network Plan",
            netConfig: "Network Configuration",
            deployMenu: "Deploy a Release",
            deployImgBySelection: "Deploy Release to Selected Base Stations",
            deployImgBySet: "Deploy Release by Set",
            updateCurrentConfigurations: "Update Active Configuration",
            restoreConfigurations: "Restore Configuration",
            restoreSaveAndUpdate: {
                title: "Save the restored changes and manually update them before deploying.",
                button: "Update and Restore",
            },
            restoreConfigValid: `Please confirm your decision to restore the configuration from: <strong>{date}.</strong>
                <br />
                <br />
                <ul>
                    <li><strong>Save and Update</strong> will overwrite any undeployed changes with the restored configuration, allowing you to modify the configuration before deployment.</li>
                    <li><strong>Deploy</strong> will immediately push the restored configuration to the base station.</li>
                </ul>`,
            restoreConfigInvalid: `The configuration from <strong>{date}</strong> has validation errors. It cannot be deployed to the base station as is.
                <br />
                <br />
                <ul>
                    <li><strong>Save and Update</strong> will save the configuration with errors, allowing you to modify and correct them before deployment.</li>
                </ul>`,
            noActiveConfig: "Cannot Perform the action since the configuration of the selected base station is not available",
            noActiveConfigToDisplay: "The active configuration for Base Station {id} is not available",
            downloadActiveConfig: "Download Active Configuration",
            exportConfig: {
                title: "Export full JSON configuration",
                button: "Export"
            },
            saveAndUpdate: "Save and Update",
            restoreConfigAction: "Restore",
            updateSavedConfigurations: "Update Saved Configuration",
            compareConfigurations: "Compare Configurations",
            saveUpdateConfig: "Save Updated Configurations",
            deployConfirmMsg: "If there are differences between the staged and active config, do you want to",
            activeImage: "Active Release",
            activeBuild: "Active Build",
            activeSoftwareBank: "Active Software Bank",
            standByImage: "Stand By Release",
            lastReleaseStatus: "Last Release Deployment Status",
            lastReleaseDate: "Last Release Deployment Date",
            lastReboot: "Last Reboot Status",
            lastRebootDate: "Last Reboot Date",
            scheduleTime: "Scheduled Reboot Date",
            scheduleStatus: "Scheduled Reboot Status",
            scheduleBank: "Scheduled Reboot Bank",
            uploadImg: "Upload Release",
            importImg: "Import Image",
            criticallyOutOfDate: "Critically Out Of Date",
            released: "Released",
            platform: "Platform",
            netConfigs: "Network Configurations",
            manageImageVersions: "Manage Image Versions",
            editImgVers: "Edit Release Versions",
            deleteImgVers: "Delete Release Versions",
            deleteImage: 'Are you sure want to delete selected Release?',
            deleteImagesSuccess: 'Selected versions got deleted',
            deleteImagesError: 'Failed to delete the selected versions',
            uploadImageSuccess: 'The release file(s) were successfully uploaded for validation.',
            updateImageVers: "Update Selected Release",
            version: "Version",
            filename:"File Name",
            content:"Content",
            successUpdateImageVers: "Successfully Updated",
            errorUpdateImageVers: "Failed To Update",
            rebootMenu: "Reboot Base Station(s)",
            rebootTowers: "Reboot Selected Base Stations",
            rebootTowersBySet: "Reboot Base Stations by Set",
            rebootAllTowers: "Reboot All Base Stations",
            cancelReboot: "Cancel Reboot",
            getMetaData: "Get Metadata",
            getMetaDataMsg: "Successfully queued command to get Metadata from base station(s)",
            getMetaDataErr: "Your request to get metadata has failed.",
            showCli: "Show Terminal",
            manifest:"Show Manifest",
            towerId:"Tower ID",
            build:"Build",
            activeBank: "Active Bank",
            standByBank: "Stand By Bank",
            deployAll: "Deploy Release to All Base Stations",
            rebootAll: "Reboot All",
            compareConfigurationsTitle: 'Compare Configurations',
            showChanges: "Show Changes",
            noChanges: "There are no changes to show.",
            noChangesDeploy: "There are no changes to deploy.",
            selectConfig: "Select Configuration",
            failedToDeploy: "Failed to deploy",
            failedToFetchImageVersions: "Failed to fetch image versions",
            successfullyPlacedForDeployment: "Successfully placed for deployment",
            deployAllTowers: "Deploy to All Base Stations",
            configCommandStatusWarning: "Cannot Perform the action since selected base station is in process of updating configurations",
            configuration: "Configuration",
            release: "Release",
            manageImages: "Manage Releases",
            startTime: "Start Time",
            errorMessage : "Error Message(s)",
            selectedImages: "Selected Versions",
            activeConfiguration: "Active Configuration",
            deployTowerSuccess: "Successfully placed for deployment",
            scheduleRebootTitle: "Set date and time(HH:MM AM/PM) to future reboot",
            scheduleReboot: "Schedule Reboot",
            rebootTowerSuccessMsg: "Reboot successfully queued",
            rebootTowerFailMsg: "Failed to queue reboot ",
            invalidRebootStatus:"Invalid Reboot Status for Cancel Reboot",
            revertUpdatesTitle: "Are you Sure you want to revert back the updates for",
            saveChangesTitle: "Do you want to save changes?",
            preview: {
                btn: "View Changes",
                title: "Preview local changes"
            },
            editorBtn: {
                btn: "View Editor",
                title: "View configuration editor"
            },
            deployChanges: {
                btn: "Deploy",
                title: "Send command to base station to deploy local changes to active configuration",
            },
            saveChanges: {
                btn: "Save",
                title: "Save changes without sending command to base station"
            },
            schemaGenDetails: "General details of current schema",
            basestationEnclosureType: "Base Station Enclosure Type",
            hostnameBaseStation: "Hostname of Base Station",
            configurationSchemaVersion: "Configuration Schema Version",
            timezone: "Timezone",
            configurationVersion: "Configuration Version",
            revertChanges: "Revert changes",
            validationError: "Validation Error",
            schemaGeneralInfo: "Schema General Info",
            configurationsSavedSuccessMsg: "Configurations Saved",
            failedSaveConfigurations: "Failed Save Configurations",
            deployingLocalChangesToBaseStation: "Deploying local changes to base station",
            deployingLocalChangesToBaseStationFailed: "Failed to deploy local changes to base station",
            saveChangesBeforeDeployError: "Failed to save configuration changes. Deploy aborted.",
            undoStaged: "Undo Staged",
            merge: "Merge",
            uploadInProgress: "Upload In Progress",
            imageVerificationInProgress: "Image verification in progress",
            imageVerificationFailed: "Image verification Failed",
            uploadCancelled: "Upload Cancelled",
            uploaded: "Uploaded",
            closeUploadDialogTitle: "Cancel all upload and close dialog",
            importFileSuccess: "Successfully imported file",
            editConfigTitle: "Continue editing local changes",
            activeConfigErrors: "Base Station Active Configuration Errors",
            newActiveConfigErrors: "Newly Staged Configuration Errors",
            preexistingActiveConfigErrors: "Active Configuration Errors Reported By The Base Station",
            noPreexistingActiveConfigErrors: "No Active Configuration Errors Reported By The Base Station",
            savedConfigErrors: "Saved Configuration Errors",
            savedConfigErrorsDescription: "The data in the saved configuration is no longer valid for the current schema and will be removed on the next save or deploy.",
            onboard: {
                action: "Onboard Base Station(s)",
                single: "Onboard/Edit a Base Station",
                selected: "Onboard Selected Base Station(s)",
                reonboardSingle: "Re-Onboard Base Station",
                set: {
                    action: "Onboard Base Stations by Set",
                    successMsg: "Successfully queued onboarding for the selected set.",
                    errorMsg: "Failed to queue onboarding for the selected set."
                },
                csv: "Onboard Base Stations via CSV File",
            },
            updateTower: {
                confirm: {
                    title: 'Confirm Base Station Action',
                    msg: 'This action will remove any staged configurations on the base station. Do you wish to proceed?'
                }
            },
            updateCerts: "Update Base Station Certifications",
            addTowerAction: "Selected base stations onboard commands sent",
            addTowerActionError: "Selected base stations onboard failed",
            addTowerActionWarning: "Selected base stations onboard completed with warnings.",
            updateTowerAction: "Selected base stations update commands sent",
            updateTowerActionError: "Selected base stations update failed",
            updateTowerDlogTitle: "Edit Base Station",
            addTowerDlogTitle: "Add a Base Station",
            showJSONEditor: "Show JSON Editor",
            showFormEditor: "Show Form Editor",
            activeConfigErrorDescription: "Active Configuration errors from the Base Station due to release change, hardware change or other changes on the Base Station",
            information: "General Information",
            missingIpAddress: "Base Station must have an IP Address {id}",
            noActiveRelease: "No Active Release found on Base Station",
            readOnlyMessage: "You do not have permissions to modify a read-only property",
            rotateAdminPswd: "Rotate tmadmin Password",
            showAdminPswd: "Show tmadmin Password",
            rotateAdminPswdRequestSent: "Sending tmadmin Rotate request to selected base stations",
            rotateAdminPswdRequestErr: "tmadmin Rotate request failed ",
            showAdminPswdRequestErr: "Showing tmadmin password failed ",
            failedReonboardBts : "Your request to onboard the base station has failed.",
            successReonboardBts : "Your request to onboard the base station has been successfully queued. It will be sent to the selected base station(s) shortly.",
            tmAdminPswd: "tmadmin Password is: ",
            tmAdminPolicy:"tmadmin Rotation Policy is: ",
            tmAdminTitle: "tmadmin Information",
            noAdminPswdResult: "No tmadmin Password set",
            schemaVersionMismatch: "The active schema isn't compatible with the past configuration.",
            editor: {
                readOnlyLint: "Note: this property is read-only.",
                redactedLint: "Note: insufficient permission to view this property.",
                statusParseError: "JSON Syntax Error - Configuration will not be saved!",
                statusSchemaError: "Validation Error",
                statusReadOnly: "Read Only",
                cmControlCharacter: "Control character",
                cmSelectionDeleted: "Selection deleted",
                cmFoldedLines: "Folded Lines",
                cmUnfoldedLines: "Unfolded Lines",
                cmTo: "to",
                cmFoldedCode: "Folded Code",
                cmUnfold: "unfold",
                cmFoldLine: "Fold line",
                cmUnfoldLine: "Unfold line",
                cmGoToLine: "Go to line",
                cmGo: "go",
                cmFind: "Find",
                cmReplace: "Replace",
                cmNext: "next",
                cmPrevious: "previous",
                cmAll: "all",
                cmMatchCase: "match case",
                cmByWord: "by word",
                cmReplaceLower: "replace",
                cmReplaceAll: "replace all",
                cmClose: "close",
                cmCurrentMatch: "current match",
                cmReplacedMatches: "replaced $ matches",
                cmReplacedMatchOn: "replaced match on line $",
                cmOnLine: "on line",
                cmCompletions: "Completions",
                cmDiagnostics: "Diagnostics",
                cmNoDiagnostics: "No diagnostics"
            },
            outOfBandWarning: "Config changed since last fetch. Please review the updated diff.",
            profiles: {
                selectProfileDialogTitle: "Select Configuration Profile",
                nav: "Configuration Profiles",
                name: "Configuration Profile Name",
                create: "Create Configuration Profile",
                edit: "Edit Configuration Profile",
                delete: {
                    action: "Delete Configuration Profile",
                    dialogText: "Are you sure you want to delete this configuration profile?"
                },
                deploy: {
                    action: "Deploy Configuration Profile",
                    toSelected: "Deploy Configuration Profile to Selected",
                    toSingle: "Deploy Configuration Profile to a Base Station",
                    toSet: "Deploy Configuration Profile to Set",
                    text: "Are you sure you want to deploy this configuration profile to the selected Base Station(s)?",
                    singleTowerText: "Are you sure you want to deploy this configuration profile to this Base Station?"
                },
                searchSchema: {
                    placeholder: "Search Schemas",
                    hint: "Select a schema to validate in the JSON editor"
                },
                dialogDescription: "As you write JSON, it will be validated against all available schemas. Only the selected schema will be validated in the JSON editor.",
                errorCreate: "Error creating configuration profile.",
                errorUpdate: "Error updating configuration profile.",
                errorDelete: "Error deleting configuration profile."
            }
        },
        db: {
            CLI: "Base Station Terminal",
            ActiveAlarms: 'Active Alarms',
            commandInCounts: 'Inbound Command Counts',
            commandInCountsTitle: 'Inbound Command Counts for the',
            Transmit: 'Downlink Commands Sent',
            TransmitGraphLabel: 'Count',
            receiveCounts: 'Uplink Messages Received',
            CommandIn: 'Downlink Commands Received',
            ackCounts: 'Ack Message Counts',
            ackCountsShort: 'Ack Counts',
            ackCountsTitle: 'Ack Message Counts for the',
            ackType: 'Ack Type',
            TowerAck: 'Ack Messages',
            TowerAckGraphLabel: 'Count',
            TowerAckTitle: 'Ack Message Counts for the',
            baseStationMessages: "Base Station Messages",
            baseStationMessagesGraphLabel: "Count",
            dupBuddyMsgCounts: 'Duplicate Buddy Message Counts',
            dupBuddyMsgCountsTitle: 'Duplicate Buddy Message Counts for the',
            AllOut: 'All Out',
            BuddyDuplicate: 'Duplicate Buddy Messages',
            BaseStationIdRange: 'ID Range',
            RadiosHeardByTower: 'Direct Radios Heard',
            RadiosHeardByTowerPercentChange: 'Radios Heard % Change (Largest recent drop)',
            RadiosHeardByTowerPercentChangeCol: 'Radios Heard % Change',
            RadiosHeardByTowerPercentChangeGraphLabel: 'Percent',
            radiosHeardByTowerDistance: 'Radios Distance to Best Base Station',
            SingleRouteRadiosByTower:'Daily Single Uplink Routes',
            SingleRouteRadiosByTowerGraphLabel: 'Radio Count',
            uniqueBuddyMsgCounts: 'Unique Buddy Message Counts',
            uniqueBuddyMsgCountsTitle: 'Unique Buddy Message Counts for the',
            BuddyUnique: 'Unique Buddy Messages',
            BuddyUniqueGraphLabel: 'Count',
            transmitCounts: 'Downlink Message Counts',
            transmitCountsTitle: 'Downlink Message Counts for the',
            transmitShort: 'Downlink Messages',
            receiveCountsTitle: 'Uplink Message Counts for the',
            CPC: 'Uplink Messages Received',
            CPCGraphLabel: 'Count',
            CPCShort: 'Uplink Messages',
            uplinkMessages: 'Uplink Messages',
            uplinkMessagesGraphLabel: 'Count',
            CommandOut: 'Downlink Commands Queued',
            CommandOutCounts: 'Outbound Command Counts',
            CommandOutGraphLabel: 'Count',
            CommandOutCountsTitle: 'Outbound Command Counts for the',
            commsHubDownlinkMsgs: 'CommsHub Downlink Commands Queued',
            commsHubDownlinkMsgsGraphLabel: 'Count',
            commsHubUplinkMsgs: 'CommsHub Uplink Messages',
            commsHubUplinkMsgsGraphLabel: 'Count',
            commsHubPingCommands: 'CommsHub Downlink Pings',
            commsHubPingCommandsGraphLabel: 'Count',
            commsHubUplinkMsgsAndIdleNoise: 'CommsHub Messages and Average Idle Noise',
            UplinkMessagesByCustomer: 'Uplink Messages Received by Customer',
            UplinkMessagesByCustomerGraphLabel: 'Count',
            UplinkTrafficTrends: 'Uplink Traffic Trends',
            downlinkMessages: 'Downlink Messages',
            downlinkMessagesGraphLabel: 'Count',
            DownlinkMessagesByCustomer: 'Downlink Messages Sent by Customer',
            DownlinkMessagesByCustomerGraphLabel: 'Count',
            idleNoiseShort: 'Idle Noise',
            highestAvgIdleNoise: 'Highest Avg Idle Noise (dB)',
            btsIdleNoise: 'Base Station Reported Idle Noise (Avg)',
            btsIdleNoiseGraphLabel: 'dB',
            IdleNoiseTitle: 'Average Idle Noise for the',
            IdleNoiseGraphLabel: 'dB',
            idleNoiseSysAvg: 'Idle Noise - Sys Avg',
            DataNoise: 'Received Endpoints Idle Noise (Avg)',
            tuningNoise: 'Tuning Noise',
            DataNoiseGraphLabel: 'dB',
            DataSignal: 'Received Endpoints Signal (Avg)',
            DataSignalGraphLabel: 'dB',
            radiosHeardGraphLabel: 'percent',
            baseStationLag: 'Average Base Station Lag',
            BaseStationLag: 'Average Base Station Lag',
            baseStationLagTitle: 'Average Base Station Lag for the',
            baseStationLagGraphLabel: 'ms lag',
            baseStationCounts: 'Base Station Messages',
            baseStationCountsAndAlarms: 'Base Station Messages And Alarms',
            baseStationCountsGraphLabel: 'Count',
            baseStationCountsAndAlarmsGraphLabel: 'Count',
            baseStationCountsTitle: 'Base Station Message Counts for the',
            currentRadioCount: 'Current Radio Count',
            targetRadioCount: 'Target Radio Count',
            loadDifference: 'Difference (Target - Current)',
            lag: 'Lag',
            ForwardPower: 'Forward Power',
            ReflectedPower: 'Reflected Power',
            vswr: 'VSWR',
            VSWR: 'VSWR',
            VSWR_Details: 'VSWR',
            VSWRTitle: 'Average VSWR for the',
            VSWRGraphLabel: 'VSWR',
            powerGraphLabel: 'Power (dB)',
            appMessages: 'App Messages',
            appMessagesGraphLabel: 'Count',
            commandsSent: 'Commands Sent',
            commandsSentGraphLabel: 'Count',
            pings: 'Pings',
            PingCommands: 'Pings',
            PingCommandsGraphLabel: 'Count',
            PingResponses: 'Ping Responses',
            PingResponsesGraphLabel: 'Count',
            pingsSent: 'Pings Sent',
            pingsSentGraphLabel: 'Count',
            cmdPriority: 'Command Priorities',
            commandPriorities: 'Command Priorities',
            commandPrioritiesGraphLabel: 'Count',
            appMessagesTitle: 'App Messages Received',
            pingResponsesTitle: 'Ping Responses Received',
            cmdPriorityTitle: 'Command Priorities',
            graphError: 'Error retrieving graph data for {graphName}',
            channelStats: 'Channel Stats',
            channelStatsGraphLabel: 'Count',
            modulation: 'Modulation',
            demodulatorType: 'Demodulator Type',
            systemAverage: 'Sys Avg',
            systemTotal: 'Sys Total',
            allChannels: 'All Channels',
            radiosHeard: 'Direct Radios Heard',
            baseStationQueueDepthTitle: 'Queue Depth',
            baseStationTotalQueueDepthTitle: 'Total Queue Depth',
            queueDepths: 'Queue Depths',
            queueDepthsGraphLabel: 'Average Messages',
            vswrAndMsgCounts: 'Base Station Messages And VSWR',
            vswrAndMsgCountsGraphLabel: 'Count',
            Temperature: 'Temperature',
            TemperatureGraphLabel: 'Temperature (°C)',
            TowerAckDetail: 'Base Station Acks',
            TowerAckDetailGraphLabel: 'Count',
            radiosTransmitted: 'Transmission Direct to Radios',
            RadiosTransmittedByTowerPercentChange: 'Radios Transmitted % Change (Largest recent drop)',
            RadiosTransmittedPercentChange: 'Radios Transmitted % Change',
            RadiosTransmittedByTowerPercentChangeCol: 'Radios Transmitted % Change',
            RadiosTransmittedByTowerPercentChangeGraphLabel: 'Percent',
            Uptime: 'Uptime',
            fec: 'FEC',
            AirTime: "Air Time",
            AirTimeGraphLabel: "Seconds",
            ChannelThroughput: "Channel Throughput",
            AirTimeByCustomer: "Air Time by Customer",
            AirTimeByCustomerGraphLabel: "Seconds",
            ChannelThroughputByCustomer: "Channel Throughput by Customer"
        },
        distanceToTower: {
            UNKNOWN: 'Unknown',
            LESS_THAN_ONE_MILE: '< 1 Mile',
            ONE_MILE_TO_LESS_THEN_THREE_MILES: '>= 1 Mile and < 3 Miles',
            THREE_MILES_TO_LESS_THEN_FIVE_MILES: '>= 3 Miles and < 5 Miles',
            FIVE_MILES_OR_MORE: '>= 5 Miles'
        },
        staleFilters: {
            Hour1: "1 Hour",
            Hour4: "4 Hours",
            Hour12: "12 Hours",
            Day1Plus: "1+ Days"
        },
        errors: {
            retrieveDetails: 'Error retrieving base station details for base station id {baseStationId}',
            createSetMaxIds: 'Too many base stations selected.  A max of {cnt} base stations can be selected when creating a set',
            addToSetMaxIds: 'Too many base stations selected.  A max of {cnt} base stations can be selected when adding to a set',
            removeFromSetMaxIds: 'Too many base stations selected.  A max of {cnt} base stations can be selected when removing from a set',
            radioSingleRoutesCount: 'Error retrieving radio single routes count',
            radioAllRoutesCount: 'Error retrieving radio all routes count',
            retrieveFrequencies: 'Error retrieving frequencies',
            retrieveCities: 'Error retrieving cities',
            retrieveTower: 'Error retrieving base stations',
            csvParseError : "An error occurred while parsing the CSV file",
            validateErr:'Error retrieving base stations for validation',
            colErr:'Invalid Column Name',
            allErr: "All Base Stations in the file had errors, no Base Stations were added.",
            retrieveRadio: 'Error retrieving radios',
            retrieveById: 'Error retrieving data by ID',
            retrieveConfig: 'Error retrieving configurations.',
            insufficientConfig: 'Insufficient configuration history on the selected base station(s)',
            retrieveBaseStationChannelLoad: 'Error retrieving base station channel load data'
        },
        statuses: {
            ON: 'Power On',
            OFF: 'Power Off',
            BATTERY: 'Low Battery',
            MAINTENANCE: 'Maintenance'
        },
        statusTypes: {
            NORMAL: 'Normal',
            NEVER_HEARD: "Never Heard",
            ON_BATTERY: "On Battery"
        },
        enclosureTypes: {
            SingleTransceiverWoFusePanel: 'Single-Transceiver Indoor TGB without Fuse Panel',
            StandardOutdoor: 'Standard Outdoor TGB with Argus/Alpha Supply',
            SingleTransceiverWFusePanel: 'Single-Transceiver Indoor TGB with Fuse Panel',
            DualTransceiver: 'Dual-Transceiver Indoor TGB with Fuse Panel',
            TripleQuadTransceiver: 'Triple/Quad Transceiver Indoor TGB with Argus/Alpha Supply',
            ApcCustomMini: 'APC Custom Mini-TGB with NewMar Supply',
            MetroOutdoor: 'Metro Outdoor TGB with Lineage Supply',
            FlexnetRemotePortal: 'FlexNet Remote Portal (FRP)',
            M400B: 'M400B with Battery',
            S1600: 'S1600E',
            R100E: 'R100E',
            R100: 'R100'
        },
        demodulatorTypes: {
            INACTIVE: 'Inactive',
            NORMAL_ONLY: 'Normal (4.x)',
            BOOST_ONLY: 'Boost (5.x)',
            CANDI_ONLY: 'C&I (6.x)',
            PRIORITY_ONLY: 'Priority (7.x)',
            DD_ONLY: 'Double density 1/2FEC (8.x)',
            NORMAL_DD: 'Normal/Double density 1/2FEC (9.x)',
            CANDI_PRIORITY: 'C&I/Priority (10.x)',
            DD_1_2FEC_AND_3_4FEC: 'Double density 1/2FEC & 3/4FEC (11.x)',
            CANDI_OR_PRIORITY_2CH: 'C&I/Priority 2ch (12.x)',
            RSVD_10: 'Reserved10',
            RSVD_11: 'Reserved11',
            RSVD_12: 'Reserved12',
            RSVD_13: 'Reserved13',
            RSVD_14: 'Reserved14',
            UNKNOWN: 'Unknown'
        },
        gpsFixes: {
            INVALID: 'Invalid',
            GPS_FIX: 'GPS Fix',
            D_GPS_FIX: 'Differential GPS Fix'
        },
        transmitModes: {
            STRICT_SYNCHRONOUS: 'Strict Synchronous',
            SYNCHRONOUS: 'Synchronous',
            SYNCHRONOUS_ABORTED: 'Synchronous (Aborted)',
            DITHERED: 'Dithered',
            UNKNOWN: 'Unknown'
        },
        softwareTypes: {
            LEGACY: 'Legacy',
            UNIFIED: 'Unified',
            UNIFIED_2: 'Unified 2',
            UNIFIED_3: 'Unified 3',
            null: 'Not Set'
        },
        deploymentType:{
            QUEUED: "Queued",
            IN_PROGRESS: "In Progress",
            FAILED: "Failed",
            COMPLETED: "Completed",
            null: 'Not Set'
        },
        temperatureComponents: {
            rf: 'RF Card',
            pa: 'Power Amplifier',
            cpc0: 'CPC Slot 0',
            cpc1: 'CPC Slot 1',
            cpc2: 'CPC Slot 2',
            cpc3: 'CPC Slot 3',
            cpc4: 'CPC Slot 4',
            cpc5: 'CPC Slot 5',
            cpc6: 'CPC Slot 6',
            cpc7: 'CPC Slot 7',
            cpc8: 'CPC Slot 8',
            cpc9: 'CPC Slot 9'
        },
        powerMonitorTypes: {
            NONE: 'No monitor attached',
            DSPM: 'DB Spectra power monitor',
            BIRD_7020: 'Bird Technologies model 7020',
            SPM: 'Sensus power monitor',
            R100: 'R100 Onboard power monitor',
            PCC: 'Sensus power control card',
            UNKNOWN: 'Unknown'
        },
        ackTypes: {
            UNKNOWN: 'Unknown',
            FNV1_BUDDY: 'FNv1 Buddy',
            FNV1_AC5: 'FNv1 AC5 Setup and Binding',
            FNV2_FT1_BUDDY: 'FNv2 FT1 (Electric) Buddy',
            FNV2_FT4_BUDDY: 'FNv2 FT4 (Arqiva) Buddy',
            FNV2_FT9_BUDDY: 'FNv2 FT9 (Battery) Buddy',
            FNV2_FT9_AC5: 'FNv2 FT9 (Battery) AC5 Binding & Tower Analysis'
        },
        ackStatus: {
            BuddyUnique: 'Unique',
            BuddyDuplicate: 'Duplicate',
            TowerAckAgeExpired: 'Expired',
            TowerAck: 'Transmitted'
        },
        addBaseStationToSet: 'Add Base Station To Set',
        removeBaseStationFromSet: 'Remove Base Station From Set',
        deleteBaseStation: 'Delete Base Station',
        detailActionsSubTitle: 'Base Station Actions',
        addTowerToSetTitle: 'Add Base Station To Set',
        removeTowerFromSetTitle: 'Remove Base Station From Set',

        channelPlanTransmit: "Transmit Channels In Channel Plan",
        channelPlanMissingTransmit: "Transmit Channels Not In Channel Plan",
        channelPlanReceive: "Receive Channels In Channel Plan",
        channelPlanMissingReceive: "Receive Channels Not In Channel Plan",

        networkPlanTransmit: "Transmit Channels In Network Plan",
        networkPlanMissingTransmit: "Transmit Channels In Network Plan Not Configured on Base Station",
        networkPlanNotPlannedTransmit: "Transmit Channels Not in Network Plan",

        networkPlanReceive: "Receive Channels In Network Plan",
        networkPlanMissingReceive: "Receive Channels In Network Plan Not Configured on Base Station",
        networkPlanNotPlannedReceive: "Receive Channels Not In Network Plan",
        lastValidatedTransmit: "Last Transmit Validation Report",
        lastValidatedReceive: "Last Receive Validation Report",
        secondsAge: "Seconds Ago (1-999)",
        resetBaselineUplinkSuccess: "Baseline Uplink Average Start Time set to {value}",
        resetBaselineConfirmMsg: "Are you sure you want to reset the start time of the baseline average calculation?",
        resetBaselineConfirmTitle: "Confirm Reset Start Time",

        resetHysteresisForRadiosWithBestTower: 'Reset Associated Endpoint Hysteresis',
        resetHysteresisForRadiosWithBestTowerSuccess: 'Hysteresis reset for associated endpoints',

        resetAnalysisDaysForBestTower: 'Reset Analysis Days for Associated Endpoints',
        resetAnalysisDaysForBestTowerSuccess: 'Analysis days reset for associated endpoints',
        resetAnalysisDaysForBestTowerFailed: 'Failed to reset analysis days for associated endpoints',

        channelBalanceTower: 'Tune and Channel Balance Base Station',
        channelBalanceTowerRequestMade: 'Tuning and Channel balancing base station',
        tuningErrorMsg: 'Tune and Channel balance base Station error, see log'
    },
    modulation: {
        FSK_DISABLED: 'Disabled',
        FSK7: '7 FSK',
        FSK13: '13 FSK 1/2 FEC',
        FSK13_R34: '13 FSK 3/4 FEC',
        FSK13_REDUCED: '13 FSK Reduced',
        FSK13_EXTENDED: '13 FSK Extended',
        FSK13_BOTH: '13 FSK Reduced + Extended',
        FSK_CNI: 'C&I (7 FSK Half-Baud)',
        FSK_PRI: 'Priority (13 FSK Half-Baud)',
        FSK_BOOST: 'Boost',
        SFSK_BOOST: 'SFSK Boost',
        SFSK2: '2 SFSK',
        SFSK4: '4 SFSK',
        SFSK8: '8 SFSK',
        SFSK16: '16 SFSK',
        SFSK2_HB: '2 SFSK Half-Baud',
        SFSK4_HB: '4 SFSK Half-Baud',
        SFSK8_HB: '8 SFSK Half-Baud',
        SFSK16_HB: '16 SFSK Half-Baud',
        MPASS: 'mPass (5 kbps)',
        MPASS2: 'mPass2 (10 kbps)',
        M4PASS: 'm4Pass (10 kbps)',
        M4PASS2: 'm4Pass2 (20 kbps)',
        MPASS12K: 'mPass 12K',
        RADIO_SFSK_2: 'Radio 2 SFSK',
        RADIO_SFSK_4: 'Radio 4 SFSK',
        UNKNOWN: 'Unknown',
        null: 'Not Set'
    },
    fec: {
        NONE: 'Uncoded',
        HALF: '½ Rate, K=3',
        THREE_QUARTER_K7: '¾ Rate, K=7',
        THREE_QUARTER_K4: '¾ Rate, K=4',
        UNKNOWN: 'Unknown',
        null: 'Not Set'
    },
    configStatus: {
        UNKNOWN: 'Unknown',
        CURRENT: 'Current',
        PENDING: 'Pending',
        QUEUED: 'Queued',
        ERROR: 'Error',
        CANCELLED: "Cancelled",
        IN_PROGRESS: 'In Progress'
    },
    configCommandStatus: {
        UNKNOWN: 'Unknown',
        QUEUED: 'Queued',
        IN_PROGRESS: 'In Progress',
        SUCCESS: 'Success',
        FAILED: 'Failed',
        CANCELLED: "Cancelled",
    },
    deploymentStatus: {
        CURRENT: 'Current',
        CURRENT_WITH_WARNINGS: 'Current with Warnings',
        NOT_DEPLOYED: 'Not Deployed',
        ERROR: 'Error',
        OUT_OF_DATE: 'Out of Date',
        QUEUED: 'Queued',
        DEPLOYING: 'Deploying'
    },
    plannedStatus: {
        PLANNED: 'Planned',
        NOT_PLANNED: 'Not Planned'
    },
    securityConfigStatus: {
        COMPLETED: 'Completed',
        FAILED: 'Failed',
        QUEUED: 'Queued',
        IN_PROGRESS: 'In Progress'
    }
}
